import React, { useCallback, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../core/actions';
import { BackgroundEffectsPanel } from '..';
import './styles.scss';
export function BackgroundEffectsModal() {
    const intl = useIntl();
    const dispatch = useDispatch();
    const containerRef = useRef();
    const close = useCallback(() => dispatch(closeModal()), [dispatch]);
    useEffect(() => {
        containerRef.current?.focus();
        function handleClick(e) {
            if (!containerRef.current.contains(e.target)) {
                /**
                 * Don't close the modal if the outside click was any of the following:
                 */
                const ALLOWED_IDS = ['backgroundEffects.options.branded.disabled'];
                if (e.target instanceof Element && ALLOWED_IDS.includes(e.target.id)) {
                    return;
                }
                close();
            }
        }
        document.addEventListener('mousedown', handleClick);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('mousedown', handleClick);
            document.body.style.overflow = 'visible';
        };
    }, [close]);
    return createPortal(<div ref={containerRef} className="background-effects__modal" role="dialog" aria-modal="true" aria-labelledby="background-effects__modal__title" tabIndex={-1} onKeyDown={({ key }) => key === 'Escape' && close()}>
      <header>
        <h2 id="background-effects__modal__title" className="background-effects__modal__title">
          <FormattedMessage id="backgroundEffects.title"/>
        </h2>
        <button className="background-effects__modal__close-button" aria-label={intl.formatMessage({ id: 'common.close' })} onClick={close}>
          <i className="icon-close"/>
        </button>
      </header>
      <BackgroundEffectsPanel />
    </div>, document.body);
}
